/* SET STATE */
export const SET_STATE_LABREQUESTSAMPLE = "SET_STATE_LABREQUESTSAMPLE"

/* LABREQUESTSAMPLES */
export const GET_LABREQUESTSAMPLES = "GET_LABREQUESTSAMPLES"
export const GET_LABREQUESTSAMPLES_SUCCESS = "GET_LABREQUESTSAMPLES_SUCCESS"
export const GET_LABREQUESTSAMPLES_FAIL = "GET_LABREQUESTSAMPLES_FAIL"

/* LABREQUESTSAMPLE */
export const GET_LABREQUESTSAMPLE = "GET_LABREQUESTSAMPLE"
export const GET_LABREQUESTSAMPLE_SUCCESS = "GET_LABREQUESTSAMPLE_SUCCESS"
export const GET_LABREQUESTSAMPLE_FAIL = "GET_LABREQUESTSAMPLE_FAIL"

/**
 * ADD LABREQUESTSAMPLE
 */
 export const ADD_NEW_LABREQUESTSAMPLE = "ADD_NEW_LABREQUESTSAMPLE"
 export const ADD_LABREQUESTSAMPLE_SUCCESS = "ADD_LABREQUESTSAMPLE_SUCCESS"
 export const ADD_LABREQUESTSAMPLE_FAIL = "ADD_LABREQUESTSAMPLE_FAIL"

 /**
 * ADD LABREQUESTSAMPLE PROCESS
 */
  export const ADD_NEW_LABREQUESTSAMPLEPROCESS = "ADD_NEW_LABREQUESTSAMPLEPROCESS"
  export const ADD_LABREQUESTSAMPLEPROCESS_SUCCESS = "ADD_LABREQUESTSAMPLEPROCESS_SUCCESS"
  export const ADD_LABREQUESTSAMPLEPROCESS_FAIL = "ADD_LABREQUESTSAMPLEPROCESS_FAIL"

/**
 * ADD LABREQUESTSAMPLE CONTROL
 */
  export const ADD_NEW_LABREQUESTSAMPLECONTROL = "ADD_NEW_LABREQUESTSAMPLECONTROL"
  export const ADD_LABREQUESTSAMPLECONTROL_SUCCESS = "ADD_LABREQUESTSAMPLECONTROL_SUCCESS"
  export const ADD_LABREQUESTSAMPLECONTROL_FAIL = "ADD_LABREQUESTSAMPLECONTROL_FAIL"
  
  
 /**
 * UPDATE LABREQUESTSAMPLE
 */
export const UPDATE_LABREQUESTSAMPLE = "UPDATE_LABREQUESTSAMPLE"
export const UPDATE_LABREQUESTSAMPLE_SUCCESS = "UPDATE_LABREQUESTSAMPLE_SUCCESS"
export const UPDATE_LABREQUESTSAMPLE_FAIL = "UPDATE_LABREQUESTSAMPLE_FAIL"

 /**
 * UPDATE LABREQUESTSAMPLE
 */
  export const UPDATE_LABREQUESTSAMPLECHECK = "UPDATE_LABREQUESTSAMPLECHECK"

/**
 * DELETE LABREQUESTSAMPLE
 */
export const DELETE_LABREQUESTSAMPLE = "DELETE_LABREQUESTSAMPLE"
export const DELETE_LABREQUESTSAMPLE_SUCCESS = "DELETE_LABREQUESTSAMPLE_SUCCESS"
export const DELETE_LABREQUESTSAMPLE_FAIL = "DELETE_LABREQUESTSAMPLE_FAIL"

/**
 * MASSIVE SAMPLE STATUS UPDATE
 */
export const MASSIVE_SAMPLE_STATUS_UPDATE = "MASSIVE_SAMPLE_STATUS_UPDATE";
export const MASSIVE_SAMPLE_STATUS_UPDATE_SUCCESS = "MASSIVE_SAMPLE_STATUS_UPDATE_SUCCESS";
export const MASSIVE_SAMPLE_STATUS_UPDATE_FAIL = "MASSIVE_SAMPLE_STATUS_UPDATE_FAIL";